import { ChangeDetectionStrategy, Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { LocaleSettings } from 'primeng/datepicker';
import { WebsocketConnectionService } from '@services/websocket/websocket-connection.service';
import { NotificationService } from '@services/utils/notification.service';
import { UserFacade } from './store/user/user.facade';
import { switchMap } from 'rxjs';
import { LanguageItem } from '@shared/interfaces';
import { PrimengLocaleLoaderService } from '@services/utils/primeng-locale-loader.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCleanupService } from '@services/utils/navigation-cleanup.service';
import { NavigationHistoryService } from '@shared/services/navigation-history.service';
import { OrderingBlockedService } from '@services/utils/ordering-blocked.service';
import { ManagerContactsRefetchService } from '@services/utils/manager-contacts-refetch.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private primengConfig: PrimeNG,
    private websocketConnectionService: WebsocketConnectionService,
    private notificationService: NotificationService,
    private userStoreFacade: UserFacade,
    private localeLoaderService: PrimengLocaleLoaderService,
    private destroyRef: DestroyRef,
    private navigationCleanupService: NavigationCleanupService,
    private navigationHistoryService: NavigationHistoryService,
    private orderingBlockedService: OrderingBlockedService,
    private managerContactsRefetchService: ManagerContactsRefetchService,
  ) {}

  ngOnInit(): void {
    this.setPrimengConfigTranslation();
    this.websocketConnectionService.connect();
    this.notificationService.observeNotifications();
    this.orderingBlockedService.observeNotifications();
    this.managerContactsRefetchService.startManagerContactsRefetch();

    //TODO отрефакторить, так как делалось быстро
    this.navigationCleanupService.setupSearchIdCleanup();
  }

  ngOnDestroy(): void {
    this.websocketConnectionService.disconnect();
  }

  private setPrimengConfigTranslation(): void {
    this.userStoreFacade.userLanguage$
      .pipe(
        switchMap((lang: LanguageItem) => {
          return this.localeLoaderService.loadLocale(lang.description.split('-')[0]);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((config: LocaleSettings) => {
        this.primengConfig.setTranslation(config);
      });
  }
}
